var React = require('react');

function EdgeRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.49998 1L6.5 6.00002L1.49998 11","stroke":"currentColor","strokeWidth":"2"}));
}

EdgeRight.defaultProps = {"width":"8","height":"12","viewBox":"0 0 8 12","fill":"none"};

module.exports = EdgeRight;

EdgeRight.default = EdgeRight;
